import { SxProps, Theme, alpha } from '@mui/material';

export const PANEL_BG_DARK = '#1B1919';

// This const is imported in theme/components.ts
// To avoid circular dependencies, move this to a separate file if something needs to be imported from the theme module in here
export const panelSx: (theme: Theme) => SxProps<Theme> = theme => ({
  backdropFilter: 'blur(16px)',
  borderRadius: '12px',
  ...(theme.palette.mode === 'dark'
    ? {
        backgroundColor: PANEL_BG_DARK,
        borderColor: 'rgba(255, 255, 255, 0.05)',
        boxShadow:
          'inset 0 1px 0 0 rgba(255, 255, 255, 0.08), 0 4px 20px rgba(0,0,0,0.4)',
      }
    : {}),

  '&.ignited': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? alpha(theme.palette.primary.main, 0.05)
        : alpha(theme.palette.primary.main, 0.1),
    border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
    boxShadow:
      theme.palette.mode === 'dark'
        ? `0 1px 0 rgba(255,255,255,0.04), 0 4px 12px rgba(0,0,0,0.4)`
        : `0 1px 0 rgba(0,0,0,0.04), 0 4px 10px rgba(0,0,0,0.08)`,
  },
  '&.danger': {
    backgroundColor: alpha(theme.palette.danger.main, 0.15),
    border: `1px solid ${alpha(theme.palette.danger.main, 0.5)}`,
    boxShadow: `inset 0 1px 0 0 ${alpha(theme.palette.danger.main, 0.1)}`,
  },

  // nested panel (using custom class to not to override MUI Paper elsewhere)
  '& .CTPanel-root:not(.ignited):not(.danger)': {
    ...(theme.palette.mode === 'dark'
      ? {
          backgroundColor: 'rgba(200, 200, 255,  0.04)',
          border: '1px solid rgba(255, 255, 255, 0.05)',
          boxShadow: `0 1px 0 rgba(255,255,255,0.04), 0 4px 12px rgba(0,0,0,0.4)`,
        }
      : {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          boxShadow: `0 1px 0 rgba(0,0,0,0.04), 0 4px 10px rgba(0,0,0,0.08)`,
        }),
    '&.tradingActivityPanel, &.matchingBidPanel': {
      '&:hover': {
        bgcolor: `${alpha(theme.palette.background.elevated, 0.4)}`,
      },
    },
    borderRadius: '8px',
  },
});
